import { useState } from "react";

const faqs = [
  {
    question: "Ma fenêtre est bloquée ouverte, que faire en attendant le technicien ?",
    answer: "Ne forcez pas la poignée ni la fenêtre. Laissez la fenêtre en position inclinée, ne la fermez pas à la main. Fermez la pièce si c'est un souci de sécurité ou de chauffage. Protégez la zone si la fenêtre bloquée empêche de fermer la porte ou expose à la pluie. Nous intervenons rapidement dans le Bas-Rhin — souvent le jour même si vous appelez le matin.",
  },
  {
    question: "Vous intervenez vite pour une fenêtre bloquée ?",
    answer: "Oui, nous comprenons qu'une fenêtre bloquée est une urgence. Nous avons des créneaux d'urgence 24h/24 dans le Bas-Rhin. Si vous appelez avant 10h, nous pouvons généralement intervenir le jour même à Strasbourg, Schiltigheim et Illkirch. Pour Haguenau, Sélestat et les communes plus éloignées, l'intervention se fait sous 24h à 48h maximum. Le déplacement est gratuit dans tout le Bas-Rhin.",
  },
  {
    question: "Y a-t-il un risque de casser la fenêtre en la débloquant ?",
    answer: "Aucun, à condition de ne pas forcer. C'est pourquoi nous déconseillons de forcer la poignée ou de tirer sur la fenêtre — cela pourrait déformer le cadre ou casser le mécanisme. Nos techniciens utilisent des outils spécifiques et une technique de déblocage mécanique qui libère la pièce bloquée sans toucher à la vitre ni au cadre. La fenêtre est garantie intacte après notre intervention.",
  },
  {
    question: "Le prix du déblocage est-il inclus dans le devis gratuit ?",
    answer: "Oui, le diagnostic et le devis sont entièrement gratuits. Le déplacement dans tout le Bas-Rhin est aussi offert. Le prix du déblocage dépend de la complexité : anti-fausse manœuvre simple à réengager, compas à remplacer, ou crémone à changer. Nous vous donnons le prix exact avant de commencer, et vous décidez. La pièce de remplacement, si nécessaire, est incluse dans le devis. Pas de frais cachés.",
  },
];

export default function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section className="bg-rose-50 py-10 md:py-14 lg:py-16">
      <div className="w-full px-4 md:px-8 lg:px-12">
        <div className="max-w-[1280px] mx-auto mx-auto">
          <p className="font-serif italic text-plum-dark text-sm md:text-base mb-3">
            Questions fréquentes
          </p>
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-plum mb-8 leading-tight">
            FAQ — Déblocage <span className="font-serif italic">oscillo-battant</span>
          </h2>
          <div className="space-y-4">
            {faqs.map((faq, i) => (
              <div key={i} className="bg-white rounded-2xl border border-rose-200 overflow-hidden">
                <button
                  className="w-full flex items-center justify-between p-5 md:p-6 text-left"
                  onClick={() => setOpenIndex(openIndex === i ? null : i)}
                >
                  <span className="font-semibold text-plum text-sm md:text-base pr-4">{faq.question}</span>
                  <div className={`w-8 h-8 rounded-full bg-rose-50 flex items-center justify-center shrink-0 transition-transform ${openIndex === i ? "rotate-180" : ""}`}>
                    <i className="ri-arrow-down-s-line text-plum" />
                  </div>
                </button>
                {openIndex === i && (
                  <div className="px-5 md:px-6 pb-5 md:pb-6">
                    <p className="text-plum-dark text-sm md:text-base leading-relaxed">{faq.answer}</p>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}